// C:\Users\clint\f1-tipping-site\frontend\src\utils\apiClient.js

import axios from 'axios';

// Create an axios instance with default config
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://f1-tipping-backend.onrender.com',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to add auth token to all requests
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add it to the headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('No authentication token found');
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If 401 Unauthorized, it could mean the token is expired
    if (error.response && error.response.status === 401) {
      console.error('Authentication error:', error.response.data);
      
      // You could redirect to login page or refresh token here
      // For example:
      // window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;